import React from 'react';
import './ServerStatus.css';

const ServerStatus = ({ status }) => {
  if (!status) {
    return (
      <div className="server-status loading">
        <span className="status-indicator"></span>
        <span>서버 상태 확인 중...</span>
      </div>
    );
  }

  if (status.status === 'offline' || status.error) {
    return (
      <div className="server-status offline">
        <span className="status-indicator"></span>
        <span>서버 오프라인</span>
      </div>
    );
  }

  return (
    <div className="server-status online">
      <span className="status-indicator"></span>
      <span>프록시 연결됨</span>
      {status.flux_server && (
        <span className="device-info" title={`FLUX: ${status.flux_server}`}>
          (FLUX 활성화)
        </span>
      )}
    </div>
  );
};

export default ServerStatus;